module.exports = __webpack_public_path__ + "img/icon_disparo_de_comunicacoes_hover.f7df3a3a.png";